import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { IApplicationDefinitionSummary } from '../../models/application-definition/application-definition-summary';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-form-picker',
  templateUrl: './form-picker.component.html',
  styleUrls: ['./form-picker.component.scss'],
})
export class FormPickerComponent implements OnChanges, AfterViewInit {
  @Output() formSelected = new EventEmitter<IApplicationDefinitionSummary>();
  @Input() form: FormGroup;
  @Input() controlName: string = 'controlName';
  @Input() placeholder: string = 'Select Form';
  @Input() label: string;
  @Input() required: boolean = false;
  @Input() applications: IApplicationDefinitionSummary[] = [];
  filteredOptions: Observable<IApplicationDefinitionSummary[]>;
  ngOnChanges(): void {
    if (!this.form) {
      this.form = new FormGroup({ [this.controlName]: new FormControl() });
    }
    if (!this.applications) return;
    this.filteredOptions = this.form.controls[this.controlName].valueChanges.pipe(
      startWith(''),
      map((value) => {
        const title = typeof value === 'string' ? value : value?.title;
        return title ? this.filter(title) : this.applications.slice();
      })
    );
  }

  ngAfterViewInit(): void {
    this.form?.controls[this.controlName].setValidators(this.autocompleteObjectValidator());
    if (this.required) {
      this.form?.controls[this.controlName].addValidators(Validators.required);
    }
  }

  displayFn(form: IApplicationDefinitionSummary): string {
    return form?.title;
  }

  autocompleteObjectValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value || typeof value === 'object') {
        return null; // Valid if the value is an object from the autocomplete options
      } else {
        let form = this.applications.find((x) => x.title.toLowerCase() === value.toLowerCase());
        if (form) {
          return null;
        }
        return { invalidAutocomplete: true }; // Invalid if the value is not an object
      }
    };
  }
  onFormSelected(form: IApplicationDefinitionSummary) {
    this.formSelected.emit(form);
  }

  private filter(title: string): IApplicationDefinitionSummary[] {
    const filterValue = title.toLowerCase();
    return this.applications.filter((option) => option.title.toLowerCase().includes(filterValue));
  }
}
